/**
 * Registration data of each child component
 */

/**
 * The type that contains tracked data of the registered component
 */

/**
 * Enum for the actions values that change the Qos status
 */
export var QosState;

(function (QosState) {
  QosState["IDLE"] = "idle";
  QosState["LOAD_COMPLETE"] = "loadComplete";
  QosState["LOAD_FAILURE"] = "loadFailure";
  QosState["UPDATE_FAILURE"] = "updateFailure";
  QosState["TIMEOUT"] = "timeout";
})(QosState || (QosState = {}));
//# sourceMappingURL=types.js.map